import { Link } from 'react-router-dom';

export default function PrivacyPolicyPage() {
  return (
    <main className="min-h-screen bg-white">
      <section className="bg-donnos-dark px-4 py-8 text-white md:px-8 lg:px-12">
        <Link to="/" className="inline-flex h-12 w-[178px] overflow-hidden rounded-md border border-white/15 bg-black/35">
          <img src="/assets/donnos-logo.png" alt="Donnos" className="h-full w-full object-contain" />
        </Link>
      </section>

      <section className="mx-auto max-w-4xl px-4 py-12 md:px-8">
        <p className="mb-2 text-sm font-extrabold uppercase tracking-wide text-donnos-green">Donnos</p>
        <h1 className="mb-6 text-3xl font-extrabold text-gray-950">Política de Privacidade</h1>
        <div className="space-y-5 text-sm leading-relaxed text-slate-600">
          <p>
            Esta Política de Privacidade explica como a Donnos coleta, utiliza e protege informações fornecidas por usuários em formulários, solicitações de orçamento, contato comercial e navegação pelo site.
          </p>
          <p>
            Podemos coletar dados como nome, email, telefone, assunto, mensagem e informações necessárias para atendimento comercial, suporte, licitações e envio de propostas.
          </p>
          <p>
            As informações são usadas para responder solicitações, elaborar cotações, prestar suporte, manter histórico de atendimento e cumprir obrigações legais aplicáveis.
          </p>
          <p>
            A Donnos adota medidas razoáveis de segurança para proteger os dados contra acesso não autorizado, alteração, divulgação ou destruição indevida.
          </p>
          <p>
            O usuário pode solicitar atualização, correção ou exclusão de seus dados pelos canais oficiais: contato@donnosvendas.com ou licitacao@donnosvendas.com.
          </p>
          <p>
            Esta política pode ser atualizada periodicamente para refletir melhorias no site, alterações operacionais ou exigências legais.
          </p>
        </div>

        <Link to="/" className="mt-8 inline-flex rounded-md bg-donnos-green px-5 py-3 text-sm font-bold text-white hover:bg-donnos-green-dark">
          Voltar ao site
        </Link>
      </section>
    </main>
  );
}
